
import { AfterViewChecked, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatMenuModule } from '@angular/material/menu';
import { PlanCardComponent } from '../plan-card/plan-card.component';
import { CustomerSearchComponent } from '../customer-search/customer-search.component';
import { CommonModalComponent } from '../common-modal/common-modal.component';
import { UpgradeMessageComponent } from '../../../../upgrade-message/upgrade-message.component';
import { NodataFoundComponent } from '../../../../widget/nodata-found/nodata-found.component';
import { TimezoneDatePipe } from '../../../../timezone-date.pipe';
import { underscoreRemovePipe } from '../../../../pipe/UnderscopeRemove';
import { NetworkTypeLabelPipe } from '../../../../pipe/network-type-label.pipe';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BsModalService } from 'ngx-bootstrap/modal';
import { debounceTime, firstValueFrom, Observable, Subscription } from 'rxjs';
import { BENEFITS_KEY, PricePlanService } from 'src/app/components/Price-subscritions/priceplanService';
import { ApiService } from 'src/app/services/api.service';
import { ExcelService } from 'src/app/services/excelService';
import { FormValidation } from 'src/app/services/FormValidation';
import { UtilService } from 'src/app/services/util.service';
import { ContractService } from 'src/app/services/contract.service';
import { B2bDocumentSetupComponent } from 'src/app/components/shared/b2b-document-setup/b2b-document-setup.component';
import Swal from 'sweetalert2';
import { CustomerService, TEXT_FIELDS } from '../customer-service.service';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-business-contacts',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    NgxDatatableModule,
    MatMenuModule,
    PlanCardComponent,
    CustomerSearchComponent,
CommonModalComponent,
    UpgradeMessageComponent,
    NodataFoundComponent,
    TimezoneDatePipe,
    underscoreRemovePipe
  ,
    NetworkTypeLabelPipe,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './business-contacts.component.html',
  styleUrls: ['./business-contacts.component.scss', '../../../../../styles/admin/style.scss', '../../../../../styles/admin/app.scss']
})
export class BusinessContactsComponent extends FormValidation implements OnInit, OnDestroy, AfterViewChecked {
  PLANMAX: number = 0;
  AVAILABLE: number = 0;
  ALLOCATED: number = 0;
  contactData: any
  MemberShipType:any;
  @ViewChild('sortTable') table: any;
  textFields: Array<Partial<TEXT_FIELDS>>;
  @Input() screenName: string;
  networkDetailForm: FormGroup;
  private modalRef: NgbModalRef;
  openbusinessModal: boolean = false;
  businessId: any;
  refreshSubcription: Subscription;
  filterSubscription: Subscription;
  searchSubscription: Subscription;
  businessDetails: any;
  allocationCards: { name: string; value: number }[] = [];
  isBusinessOrEnterpriseUser: boolean = false;

  role:any
  constructor(
    private router: Router,
    private _activated_route: ActivatedRoute,
    private apiService: ApiService,
    private customerService: CustomerService,
    private pricePlanService: PricePlanService,
    private modalService: BsModalService,
    private excel: ExcelService,
    private renderer: Renderer2, private el: ElementRef,
    private util: UtilService,
    private contractService: ContractService) {
    super();

    this.refreshSubcription = this.customerService.getRefreshKey().subscribe(ress => {
      if (ress === "businessContacts") {

        this.nextPage({offset:0})
      }
    });

    this.filterSubscription = this.customerService.getFilterValue().subscribe(res => {
      if (res.key === 'businessContacts') {
        this.params.page = 1;
        this.params.status = res.value.status;
        this.params.searchContent = null;
        this.params.type = res.value.type;
        if (Array.isArray(res.value.businessNetworkId)) {
            this.params.businessNetworkId = res.value.businessNetworkId.join(',');
        }
        this.customerService.setFilterPayload(this.params);
        this.getContacts();
      }
    });


    this.searchSubscription = this.customerService.getSearchValue().pipe(
      debounceTime(1000),
    ).subscribe(response => {
      if (response.key === "businessContacts") {
        this.params.page = 1;
        this.params.searchContent = response.value;
        this.getContacts();
      }
    });


    // Find the route with resolver data by walking up the tree
    // For nested routes under componentless wrappers, data may be at parent or parent.parent
    let routeWithData = this._activated_route.parent;
    while (routeWithData && !routeWithData.snapshot.data['data']) {
      routeWithData = routeWithData.parent;
    }

    if (routeWithData) {
      routeWithData.data.subscribe(res => {
        if (res?.data) {
          this.businessId = res.data.id;
          this.role = res.data.role;
          this.MemberShipType = res.data.plan;
          this.businessDetails = res.data;

          // Initialize after MemberShipType is available
          this.initializeAllocationCards();
          this.checkUserPlan(this.MemberShipType);
        }
      });
    }
    this.textFields = [
      { label: "Business Name", key: "businessName", value: null, type: "STRING" },
      { label: "Owner", key: "businessOwner", value: null, type: "STRING" },
      { label: "Email", key: "businessEmail", value: null, type: "STRING" },
      { label: "Role", key: "userType", value: "Super Admin", type: "STRING" },
      { label: "Business Type", key: "type", value: null, type: "STRING" },
      { label: "Partner since", key: "startDate", value: null, type: "DATE" },
      { label: "Last Active", key: "lastLoggedIn", value: null, type: "DATE" },
      { label: "Status", key: "connectionStatus", value: null, type: "STRING" },
      { label: "Network Name", key: "businessNetworks", value: null, type: "LIST" },
    ]
  }

  public listToShow: Array<any> = []

  public selected = [];
  ngOnInit(): void {
    this.getContacts();

    // Auto-open Add Business modal when routed with supplierBusinessId or
    // customerBusinessId. Customer-side (Initiate Contract / "Invite Supplier")
    // uses supplierBusinessId. Supplier-side (OFFER-ACCEPT / "Invite Customer")
    // uses customerBusinessId — backend returns the job owner as the target.
    this._activated_route.queryParams.subscribe(params => {
      const supplierBizId = params['supplierBusinessId'];
      const customerBizId = params['customerBusinessId'];
      const customerBizName = params['customerBusinessName'];
      if (supplierBizId) {
        this.supplierBusinessId = supplierBizId;
        this.customerBusinessId = '';
        this.customerBusinessName = '';
        this.selectedBusinessEmail = '';
        this.openbusinessModal = false;
        this.showModal = true;
      } else if (customerBizId) {
        this.customerBusinessId = customerBizId;
        this.customerBusinessName = customerBizName || '';
        this.supplierBusinessId = '';
        this.selectedBusinessEmail = '';
        this.openbusinessModal = false;
        this.showModal = true;
      }
    });
  }

  onSort(event) {
    const currentPage = this.params.page-1;
    this.table.offset = currentPage;
  }

  checkUserPlan(memberShipType: string) {
    this.isBusinessOrEnterpriseUser = this.customerService.isBusinessOrEnterprise(memberShipType);
  }

  initializeAllocationCards() {
    const defaultValues = this.MemberShipType === "Free"
      ? [250, 0, 250]
      : [null, null, null];

    const cardNames = ["Plan Max", "Allocated", "Available"];
    this.allocationCards = cardNames.map((name, index) => ({
      name,
      value: defaultValues[index],
    }));
  }

  scrollSynced = false;
  bodyScrollUnlistener: () => void;
  resizeUnlistener: () => void;

  ngAfterViewChecked() {
    const dataTableBody = this.el.nativeElement.querySelector('.datatable-body');
    const dataTableHeader = this.el.nativeElement.querySelector('.datatable-header');

    if (!this.isFirefox()) {
      // If it's not Firefox, no need for custom scroll handling
      return;
    }

    if (dataTableBody && dataTableHeader && !this.scrollSynced) {
      // Clean up any previous listeners to avoid duplicates
      if (this.bodyScrollUnlistener) {
        this.bodyScrollUnlistener();
      }
      if (this.resizeUnlistener) {
        this.resizeUnlistener();
      }

      // Scroll listener to sync body and header scrolls
      this.bodyScrollUnlistener = this.renderer.listen(dataTableBody, 'scroll', this.throttle(() => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      }, 10)); // Throttle the scroll event to improve performance

      // Listener for window resize to ensure the header remains aligned
      this.resizeUnlistener = this.renderer.listen(window, 'resize', () => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      });

      this.scrollSynced = true; // Mark scroll syncing as done
    }
  }


  isFirefox(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }


  throttle(fn: Function, wait: number) {
    let time = Date.now();
    return function () {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    };
  }

  getTooltipText(businessNetworks: string | string[]): string {
    if (!businessNetworks || businessNetworks.length === 0) {
      return '';
    }
    const networks = Array.isArray(businessNetworks) ? businessNetworks : businessNetworks.split(',');
    return networks.map(name => name.trim()).join('\n');
  }

  getNetworkDisplayName(businessNetworks: string | string[]): { name: string, count: number } {
    if (!businessNetworks || businessNetworks.length === 0) {
      return {
        name: '',
        count: 0
      };
    }
    const networks = Array.isArray(businessNetworks) ? businessNetworks : businessNetworks.split(',').map(name => name.trim());
    return {
      name: networks[0],
      count: networks.length - 1
    };
  }
  closeModal(data?) {
    this.showModal = false;
    this.modalService.hide(this.modalService.getModalsCount());

  }
  selectedItem: string = 'businessContacts';
  selectedBusinessEmail: string;
  async openmodalofcontact(row) {
    this.util.startLoader();
    const plan = await this.customerService.getBusinessPLanBenefits(this.businessId , "B2B_CONTACTS");

    if(plan.available > 0){
      this.selectedBusinessEmail = row.businessEmail;
      let peerContactType = null;
      let peerSubContractAllowed = false;

      // For REQUEST_RECEIVED, fetch the initiator's type from the details API
      if (row.connectionStatus === 'REQUEST_RECEIVED') {
        try {
          const detailsRes = await firstValueFrom(
            this.apiService.create('business/findB2BContactDetails', {
              businessId: row.businessId,
              peerBusinessId: this.businessId,
              limit: 1,
              page: 1
            })
          );
          if (detailsRes?.code === '00000') {
            peerContactType = detailsRes.data?.businessModel?.peerContactType || null;
            peerSubContractAllowed = detailsRes.data?.businessModel?.subContractAllowed ?? false;
          }
        } catch (e) {
          // Non-blocking — validation just won't be available
        }
      }

      this.businessDetails = { ...this.getNetworkParams(row), peerContactType, peerSubContractAllowed };
      this.openbusinessModal = true;
      this.showModal = true;
    }
    else{
      this.pricePlanService.expiredPopup(
        "B2B_CONTACTS",
        "PAY",
        null,
        null,
        null,
        null,
        plan.available,
        plan.actual,
        plan.utilized,
        plan.promotional
      );
    }

    this.util.stopLoader();
  }
  removeUserContact(value: any) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })
    swalWithBootstrapButtons.fire({
      title: `Are you sure you want to remove ${value.businessName}?`,
      icon: 'warning',
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.util.startLoader();
        this.apiService.delete(`business/removeB2BContact/${this.businessId}/${value.businessId}`).subscribe(
          (res) => {
            this.util.stopLoader();
            if (res.code === '00000') {
              Swal.fire({
                icon: 'success',
                title: 'Contact removed successfully',
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                this.ngOnInit();
              });
            }
          },
          (error) => {
            this.util.stopLoader();
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Something went wrong. Please try again later.',
              showConfirmButton: false,
              timer: 4000,
            });
          }
        );
      }
    });
  }


  ngOnDestroy(): void {

    if (this.refreshSubcription) {
      this.refreshSubcription.unsubscribe();
    }

    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }

    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }

    if (this.bodyScrollUnlistener) {
      this.bodyScrollUnlistener();
    }
    if (this.resizeUnlistener) {
      this.resizeUnlistener();
    }
  }

  businessName: string;
  bid: string;


  params: any = {
    limit: 10,
    page: 1,
    total: 0
  };
  handleInvite(value: any, action: 'REJECT' | 'CANCEL') {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })
    let contactStatus: string;
    let successMessage: string;

    switch (action) {
      case 'REJECT':
        contactStatus = "REJECTED";
        successMessage = "Contact request rejected";

        swalWithBootstrapButtons.fire({
          title: `Are you sure you want to reject ${value.businessName}?`,
          icon: 'warning',
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.processInvite(value, contactStatus, successMessage, action);
          }
        });
        break;

      case 'CANCEL':
        contactStatus = "CANCELLED";
        successMessage = "Contact request cancelled";
        this.processInvite(value, contactStatus, successMessage, action);
        break;

      default:
        contactStatus = "";
        successMessage = "";
    }
  }

  processInvite(value: any, contactStatus: string, successMessage: string, action: string) {
    const data = {
      peerBusinessId: value.businessId,
      businessId: this.businessId,
      contactStatus: contactStatus,
    };

    this.util.startLoader();
    this.apiService.create("business/updateB2BContact", data).subscribe(
      (res) => {
        this.util.stopLoader();
        if (res.code == "00000") {
          Swal.fire({
            icon: "success",
            title: successMessage,
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.updateRowStatus(value, contactStatus);
            this.ngOnInit();
          });

          // Show B2B document setup modal on accept, then chain assign employees swal for customer
          if (contactStatus === 'CONNECTED') {
            const mode = (value.peerContactType === 'Supplier' || value.contactType === 'Supplier') ? 'customer' : 'supplier';
            this.contractService.getB2BContact(this.businessId, value.businessId).subscribe((b2bRes: any) => {
              const b2bContactId = b2bRes?.data?.b2bContact?.b2bContactId;
              if (b2bContactId) {
                this.modalService.show(B2bDocumentSetupComponent, {
                  initialState: {
                    b2bContactId,
                    myBusinessId: this.businessId,
                    peerBusinessId: value.businessId,
                    peerBusinessName: value.businessName,
                    mode
                  },
                  class: 'modal-lg',
                  backdrop: 'static',
                  keyboard: false
                });
                if (mode === 'customer') {
                  const swalWithBootstrapButtons = Swal.mixin({
                    customClass: { confirmButton: 'btn btn-success' },
                    buttonsStyling: false
                  });
                  const onHiddenSub = this.modalService.onHidden.subscribe(() => {
                    onHiddenSub.unsubscribe();
                    swalWithBootstrapButtons.fire({
                      title: 'Assign Business Employees',
                      text: 'Now that you have connected to the business contact. Please, map your employees that you want to work with this business.',
                      icon: 'question',
                      confirmButtonText: 'OK',
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      reverseButtons: true,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        this.router.navigate(['/user-management/businessContacts/businessConnectEdit'], {
                          queryParams: { id: this.businessId, contactBusinessId: value.businessId }
                        });
                      }
                    });
                  });
                }
              }
            });
          }
        } else {
          Swal.fire({
            icon: "info",
            title: "Oops...",
            text:
              action === 'REJECT'
                ? "Connection reject request failed. Please try after a while."
                : "Something went wrong. Please try after some time.",
            showConfirmButton: false,
            timer: 4000,
          });
        }
      },
      (error) => {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong. Please try again later.",
          showConfirmButton: false,
          timer: 4000,
        });
      }
    );
  }

  updateRowStatus(updatedRow: any, status: string) {
    this.listToShow = this.listToShow.map(row => {
      if (row.businessId === updatedRow.businessId) {
        row.connectionStatus = status;
      }
      return row;
    });
  }


  openViewModal(datas: any) {
    if (datas) {
      Object.keys(datas).map(key => {
        this.textFields.forEach(vv => {

          if (vv.label === "Allocated" || vv.label === 'Available') {
            vv.value = this.curryObject(datas, 'benefitsUsageAndBalance')(vv.label === "Allocated" ? "actual" : "available");
            return;
          }

          const statusMapping = {
            'REQUEST_RECEIVED': 'Request Received',
            'REQUEST_SENT': 'Requested',
            'CONNECTED': 'Connected'
          };


          if (vv.key == key) {
            if (key === 'connectionStatus') {
              vv.value = statusMapping[datas[key]] || datas[key];
            } else {

              if (Array.isArray(datas[key]) && datas[key].length === 0) {
                vv.value = "N/A";
              } else if (datas[key] === null || datas[key] === '' || datas[key] === undefined) {
                vv.value = "N/A";
              } else if (key === 'type' && typeof datas[key] === 'string'
                && datas[key].trim().toLowerCase() === 'client_supplier') {
                // Backend stores the canonical "Client_Supplier"; show "Client/Supplier"
                // in the details popup, matching the listing column's networkTypeLabel pipe.
                vv.value = "Client/Supplier";
              } else {
                vv.value = datas[key];
              }
            }
          }
        });
      });
    }
    if (this.textFields) {
      this.openView("Business Details", this.textFields, this.modalService,this.util);
    }
  }
  showModal: boolean = false;
  supplierBusinessId: string = '';
  customerBusinessId: string = '';
  customerBusinessName: string = '';
  navigateToUpgrade() {
    // Navigate to upgrade page
    this.router.navigate(['/upgrade']);
  }
  getContacts() {
    this.params.businessId = this.businessId;
    // this.params.status = 'ACTIVE';
    this.util.startLoader()
    this.getContactList(this.params)
      .subscribe({
        next: (res) => {
          if(res) {
            this.util.stopLoader()
          }
          if (res && res.code === "00000") {
            const contactData = res.data?.b2bContacts;
            this.listToShow = contactData ? contactData : [];
            this.params.total = res.data?.total || 0;

            if (this.listToShow.length === 0) {
              this.params.total = 0;
            }
            this.excel.setCount(res.data?.total);
            let plan = res.data.businessPlanUsage

            if (plan) {

              let found = (plan.benefitsUsages && plan.benefitsUsages.
                find(x => (x.benefitKey as BENEFITS_KEY) === 'B2B_CONTACTS'));
              let membershipType = res.data.businessPlanUsage.membershipType;
              if (found) {
                this.PLANMAX = found.actual == 99999999 ? 'Unlimited' : found.actual;
                this.AVAILABLE = found.actual == 99999999 ? 'Unlimited' : found.available;
                this.ALLOCATED = found.utilized;
                this.allocationCards = [
                  { name: "Plan Max", value: this.PLANMAX },
                  { name: "Allocated", value: this.ALLOCATED },
                  { name: "Available", value: this.AVAILABLE },
                ];
              }
              if (found && membershipType) {
                let plandetails = {
                  actual: found.actual,
                  available: found.available,
                  promotional: found.promotional,
                  utilized: found.utilized,
                  membershipType: membershipType
                };
              }

            }

          }
        },
        error: (error) => {
          this.util.stopLoader()
          // console.error('Subscribe Error:', error); // Log any error in the subscribe block
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while fetching data. Please try again later.",
          });
        }
      });
  }

  getContactList(payload: Object): Observable<any> {
    return this.apiService.create('business/findB2BContactsList', payload);
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }
  nextPage(data: any) {
    this.params.page = data.offset + 1;
    if (this.params.page == 1) {
      this.params.page = 1;
    }

    this.getContacts();

  }
  getNetworkParams(row) {
    return { ...this.businessDetails, contactBusinessId: row.businessId };
  }

}

